import { ReportReduxState, ReportCommonReduxTypes, ReportReducerDispatch, DownloadReportReduxState } from "./types";

const LIST_REPORTS_INIT_STATE = {
  data: {
    metadata: {
      totalCount: 0,
      currentPageRecords: 0,
      totalPages: 0,
      links: {
        self: null,
        first: null,
        previous: null,
        next: null,
        last: null
      }
    },
    records: []
  },
  loading: false,
  error: null
};

const ListReportReducer = (state: ReportReduxState = LIST_REPORTS_INIT_STATE, action: ReportReducerDispatch) => {
  switch (action.type) { 

    case ReportCommonReduxTypes.LIST_REPORT: {
      return {
        ...state,
        loading: true
      };
    }
    case ReportCommonReduxTypes.LIST_REPORT_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case ReportCommonReduxTypes.LIST_REPORT_ERROR: {
      return {
        data: {},
        error: action.payload.error,
        loading: false
      };
    }
    case ReportCommonReduxTypes.RESET: {
      return {
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
        }
      },        
        
        loading: false     
      };
    }
    
    default:
      return { ...state };
  }
};

const DOWNLOAD_REPORT_INIT_STATE = {
  loading: false,
  data: null,
  error: null,
}

const DownloadReportReducer = (state: DownloadReportReduxState = DOWNLOAD_REPORT_INIT_STATE, action: ReportReducerDispatch) => {
  switch (action.type) {
    case ReportCommonReduxTypes.DOWNLOAD_REPORT: {
      return {
        ...state,
        error: null,
        loading: true
      };
    }
    case ReportCommonReduxTypes.DOWNLOAD_REPORT_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case ReportCommonReduxTypes.DOWNLOAD_REPORT_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case ReportCommonReduxTypes.RESET:
          return {
            ...state,
            loading: false,
            data: null,
            error: null
          };
    default:
      return { ...state };
  }
};
export { ListReportReducer , DownloadReportReducer};
